import {
  USStates,
  BESValue,
  LEGValue,
  DebtValue,
  LoanReasons,
  EducationalLevel,
  EmploymentStatus,
  PaymentFrequency,
} from '@/types/form';

export function calculateBESAndLEGValues(state: USStates | null): {
  BES: number;
  LEG: number;
} {
  if (!state) return { BES: 0, LEG: 0 };
  const stateAbbr = state as keyof typeof BESValue;

  const BES = BESValue[stateAbbr as keyof typeof BESValue];
  const LEG = LEGValue[stateAbbr as keyof typeof LEGValue];

  return { BES, LEG };
}

export function calculateADVValue(value: DebtValue | null) {
  switch (value) {
    case '$0 - $9,999':
      return 0;
    case '$10,000 - $14,999':
      return 0;
    case '$15,000 - $19,999':
      return 0;
    case '$20,000 - $29,999':
      return 1;
    case '$30,000 - $39,999':
      return 2;
    case '$40,000 - $49,999':
      return 2;
    case '$50,000 - $59,999':
      return 3;
    case '$60,000 - $69,999':
      return 3;
    case '$70,000 - $79,999':
      return 4;
    case '$80,000 - $89,999':
      return 4;
    case '$90,000 - $99,999':
      return 4;
    case '$100,000+':
      return 4;
    default:
      return 0;
  }
}

export function calculateRLAValue(value: number) {
  if (value >= 1000 && value < 10000) {
    return 1;
  }
  if (value >= 10000 && value < 20000) {
    return 2;
  }
  if (value >= 20000 && value < 30000) {
    return 3;
  }
  if (value >= 30000 && value < 40000) {
    return 4;
  }
  if (value >= 40000 && value < 50000) {
    return 5;
  }
  if (value >= 50000 && value < 60000) {
    return 6;
  }
  if (value >= 60000 && value < 70000) {
    return 7;
  }
  if (value >= 70000 && value < 80000) {
    return 8;
  }
  if (value >= 80000 && value < 90000) {
    return 9;
  }
  if (value >= 90000) {
    return 10;
  }
  return 0;
}

export function setLoanPurpose(value: LoanReasons | null) {
  switch (value) {
    case LoanReasons.credit_card_refinance:
      return 'credit_card_refi';
    case LoanReasons.debt_consolidation:
      return 'debt_consolidation';
    case LoanReasons.home_improvement:
      return 'home_improvement';
    default:
      return '';
  }
}

export function setOwnership(
  value: 'rent' | 'own with outright' | 'own with mortgage' | null
) {
  switch (value) {
    case 'rent':
      return 'Rent';
    case 'own with mortgage':
      return 'Own with Mortgage';
    case 'own with outright':
      return 'Own Outright';
    default:
      return 'rent';
  }
}

export function setEducationLevel(value: EducationalLevel | null) {
  switch (value) {
    case EducationalLevel.high_school_diploma:
      return 'high_school';
    case EducationalLevel.associate_degree:
      return 'Associate';
    case EducationalLevel.bachelor_degree:
      return 'Bachelors';
    case EducationalLevel.master_degree:
      return 'Masters';
    case EducationalLevel.other_degree:
      return 'other_grad_degree';
    case EducationalLevel.other:
      return 'Other';
    default:
      return 'Other';
  }
}

export function setEmploymentStatus(value: EmploymentStatus | null) {
  switch (value) {
    case EmploymentStatus.employed:
      return 'Employed';
    case EmploymentStatus.employed_full_time:
      return 'employed_full_time';
    case EmploymentStatus.employed_part_time:
      return 'employed_part_time';
    case EmploymentStatus.military:
      return 'Military';
    case EmploymentStatus.not_employed:
      return 'not_employed';
    case EmploymentStatus.self_employed:
      return 'self_employed';
    case EmploymentStatus.retired:
      return 'Retired';
    case EmploymentStatus.other:
      return 'other';
    default:
      return 'other';
  }
}

export function setPaymentFrequency(value: PaymentFrequency | null) {
  switch (value) {
    case PaymentFrequency.monthly:
      return 'Monthly';
    case PaymentFrequency.biWeekly:
      return 'biweekly';
    case PaymentFrequency.semiMonthly:
      return 'twice_monthly';
    case PaymentFrequency.weekly:
      return 'Weekly';
    default:
      return 'Monthly';
  }
}

export function setSocialSecNumber(value: string) {
  const rawValue = value.replace(/\D/g, '');
  return rawValue;
}
